import { Box, Typography, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField } from '@mui/material';
import { Edit, Delete, Visibility, CheckCircle } from '@mui/icons-material';
import { Gallery } from '../../types';

interface GalleriesTableProps {
  galleries: Gallery[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (gallery: Gallery) => void;
  onDelete: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

export function GalleriesTable({ galleries, loading, total, page, limit, onPageChange, onEdit, onDelete, onTogglePublic }: GalleriesTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Фото</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {galleries.map((gallery) => (
            <TableRow key={gallery.id} hover>
              <TableCell>{gallery.title}</TableCell>
              <TableCell>{gallery.images?.length || 0}</TableCell>
              <TableCell>
                <Chip 
                  label={gallery.isPublic ? 'Публичная' : 'Приватная'} 
                  size="small" 
                  color={gallery.isPublic ? 'success' : 'default'}
                />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр">
                    <IconButton size="small"><Visibility fontSize="small" /></IconButton>
                  </Tooltip>
                  <Tooltip title="Редактировать">
                    <IconButton size="small" onClick={() => onEdit(gallery)}><Edit fontSize="small" /></IconButton>
                  </Tooltip>
                  <Tooltip title={gallery.isPublic ? 'Скрыть' : 'Опубликовать'}>
                    <IconButton size="small" onClick={() => onTogglePublic(gallery.id)}>
                      <CheckCircle fontSize="small" color={gallery.isPublic ? 'success' : 'disabled'} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить">
                    <IconButton size="small" onClick={() => onDelete(gallery.id)} sx={{ color: 'error.main' }}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {galleries.length === 0 && !loading && (
            <TableRow><TableCell colSpan={4} align="center"><Typography color="text.secondary">Галереи не найдены</Typography></TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, newPage) => onPageChange(newPage + 1)} rowsPerPage={limit} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}

interface GalleriesToolbarProps { search: string; onSearchChange: (value: string) => void; }
export function GalleriesToolbar({ search, onSearchChange }: GalleriesToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
      <TextField label="Поиск" variant="outlined" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 200 }} />
    </Box>
  );
}
